// src/App2.jsx
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import AnimatedLayout    from './components/AnimatedLayout';
import WidgetLoader      from './components/WidgetLoader';
import AppLayout         from './components/AppLayout';
import Login             from './pages/Login';
import Signup            from './pages/Signup';
import Search            from './pages/Search';
import Results           from './pages/Results';
import LoadBooking       from './pages/LoadBooking';  // Renamed from Detail
import Confirm           from './pages/Confirm';

export default function App() {
  const { pathname } = useLocation();
  const showWidget = !['/login','/signup'].includes(pathname);

  return (
      <AnimatedLayout>
        {showWidget && (
          <WidgetLoader agentId={process.env.REACT_APP_CONVAI_AGENT_ID} />
        )}

        <Routes>
          {/* public routes */}
          <Route path="/" element={<Navigate to="/search" replace />} />
          <Route path="/login"  element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          {/* all authenticated pages go inside AppLayout */}
          <Route element={<AppLayout />}>
            <Route path="/search"  element={<Search />} />
            <Route path="/results" element={<Results />} />
            <Route path="/booking/:id" element={<LoadBooking />} />
            <Route path="/detail/:id" element={<LoadBooking />} /> {/* Keep old route for compatibility */}
            <Route path="/confirm" element={<Confirm />} />
          </Route>
        </Routes>
      </AnimatedLayout>
  );
}